<template>
  <div class="my_margin_layer m-lr-11" @mousedown.stop :class="'my_margin_' + pattern">
    <div class="func_panel_item_wrap panel_item_margin">
      <div class="item_line">
        <span class="panel_item_title" v-text="title" :style="`width: ${titleWidth}px;`"></span>
        <span>
          <span>
            <div class="func_panel_handle_row">
              <div classs="jz_margin_component">
                <div class="margin_border_box">
                  <div class="margin_input_title title_top">{{$t('components_my_margin_index_2362')}}</div>
                  <div class="jz-input-number margin_input_top">
                    <my_input_number
                      titleWidth="0"
                      :value.sync="margin_top_display"
                      :min="margin_top_min"
                      :max="margin_top_max"
                      @change="(e)=>{setMargin(e,'marginTop')}"
                    ></my_input_number>
                  </div>

                  <div class="margin_input_title title_right">{{$t('components_my_margin_index_2363')}}</div>
                  <div class="jz-input-number margin_input_right">
                    <my_input_number
                      titleWidth="0"
                      :value.sync="margin_right_display"
                      :min="margin_right_min"
                      :max="margin_right_max"
                      @change="(e)=>{setMargin(e,'marginRight')}"
                    ></my_input_number>
                  </div>

                  <div class="margin_input_title title_bottom">{{$t('components_my_margin_index_2364')}}</div>
                  <div class="jz-input-number margin_input_bottom">
                    <my_input_number
                      titleWidth="0"
                      :value.sync="margin_bottom_display"
                      :min="margin_bottom_min"
                      :max="margin_bottom_max"
                      @change="(e)=>{setMargin(e,'marginBottom')}"
                    ></my_input_number>
                  </div>

                  <div class="margin_input_title title_left">{{$t('components_my_margin_index_2365')}}</div>
                  <div class="jz-input-number margin_input_left">
                    <my_input_number
                      titleWidth="0"
                      :value.sync="margin_left_display"
                      :min="margin_left_min"
                      :max="margin_left_max"
                      @change="(e)=>{setMargin(e,'marginLeft')}"
                    ></my_input_number>
                  </div>

                </div>
              </div>
            </div>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

// 最大值规则
//上下是300%
//挂件左右80%
//通栏和列左右40%
export default {
  name: 'my_margin_index',
  props: {
    symbol: {
      type: String,
      default: 'px'
    },
    title: { // 组件的标题
      type: String,
      default: i18n.t('widgets_basic_banner_edit_438')
    },
    titleWidth: {
      type: String,
      default: '55'
    },
    marginTop: {
      type: String
    },
    marginBottom: {
      type: String
    },
    marginRight: {
      type: String
    },
    marginLeft: {
      type: String
    },
    marginTopMin: {
      type: Number,
      default: 0
    },
    marginTopMax: {
      type: Number,
      default: 3
    },
    marginBottomMin: {
      type: Number,
      default: 0
    },
    marginBottomMax: {
      type: Number,
      default: 3
    },
    marginLeftMin: {
      type: Number,
      default: 0
    },
    marginLeftMax: {
      type: Number,
      default: 0.8
    },
    marginRightMin: {
      type: Number,
      default: 0
    },
    marginRightMax: {
      type: Number,
      default: 0.8
    },
    marginTopDisabled: {
      type: Boolean,
      default: false
    },
    marginBottomDisabled: {
      type: Boolean,
      default: false
    },
    marginLeftDisabled: {
      type: Boolean,
      default: false
    },
    marginRightDisabled: {
      type: Boolean,
      default: false
    },
    isPadding: { // 是否是内边距，默认是内边距
      type: Boolean,
      default: true
    },
    box_width:{
      type: Number,
      default: 0
    },
    pattern: {
      type: String,
      default:'default',//default 默认 ，special 特殊
    },
  },
  data () {
    return {
      margin_top: this.marginTop, // 用来保存的值
      margin_top_display: 0,// 用来显示的值
      margin_bottom: this.marginBottom,// 用来保存的值
      margin_bottom_display: 0,// 用来显示的值
      margin_right: this.marginRight,// 用来保存的值
      margin_right_display: 0,// 用来显示的值
      margin_left: this.marginLeft,// 用来保存的值
      margin_left_display: 0,// 用来显示的值
      margin_top_is_show: true,
      margin_bottom_is_show: true,
      margin_left_is_show: true,
      margin_right_is_show: true,
      margin_top_min: this.marginTopMin,
      margin_bottom_min: this.marginBottomMin,
      margin_left_min: this.marginLeftMin,
      margin_right_min: this.marginRightMin,
      top_max: 0,
      bottom_max: 0,
      left_max: 0,
      right_max: 0,
    }
  },
  created () {
    //this.init_data_max()
    this.init_data()
  },
  mounted () {
    // let this_ = this
    // this.globalResizeWidth(() => {
    //   this_.init_data_max()
    // })
  },
  watch: {
    marginTop(val){
      this.margin_top = val;
      this.init_data();
    },
    marginLeft(val){
      this.margin_left = val;
      this.init_data();
    },
    marginRight(val){
      this.margin_right = val;
      this.init_data();
    },
    marginBottom(val){
      this.margin_bottom = val;
      this.init_data();
    }
    // margin_top_display (val) { // 数据双向绑定
    //   this.setMargin(val, 'marginTop')
    // },
    // margin_bottom_display (val) { // 数据双向绑定
    //   this.setMargin(val, 'marginBottom')
    // },
    // margin_right_display (val) { // 数据双向绑定
    //   this.setMargin(val, 'marginRight')
    // },
    // margin_left_display (val) { // 数据双向绑定
    //   this.setMargin(val, 'marginLeft')
    // }
  },
  computed: {
    screenWidth () {
      return Math.ceil(this.$store.state.app.screenWidth)
    },
    margin_left_max(){
      return Math.ceil(this.marginLeftMax * this.box_width_calculation());
    },
    margin_right_max(){
      return Math.ceil(this.marginRightMax * this.box_width_calculation());
    },
    margin_bottom_max(){
      return Math.ceil(this.marginBottomMax * this.box_width_calculation());
    },
    margin_top_max(){
      return Math.ceil(this.marginTopMax * this.box_width_calculation());
    },
  },
  methods: {
    clickEvent (key, value) {
      this[key] = value
      let ref = key.replace('_is_show', '')
      if (!value) {
        this.$nextTick(() => {
          this.$refs[ref].focus()
        })
      }
    },
    numberCheck (key) {
      this[key] = parseInt(this[key])
      if (!this[key]) {
        this[key] = 0
      }
    },
    box_width_calculation(){
      let r = document.documentElement.clientWidth || document.body.clientWidth;
      if(this.box_width > 0){
        r = this.box_width;
      }
      else{
        if(this.pattern === 'special'){
          if(this.$store.state.app.edit_column){
            r = $(`#u${this.$store.state.app.edit_column.widgets_id}`).parent().width();
          }
        }
        else{
          if(this.$store.state.app.module_Data){
            r = $(`#u${this.$store.state.app.module_Data.widgets_id}`).parent().width();
          }

        }
      }
      return r
    },
    setMargin (margin, key) {
      let percentage = '0%'
      if (margin !== 0) {
        percentage = parseFloat(margin / this.box_width_calculation() * 100).toFixed(4) + '%'
      }
      this.$emit('update:' + key, percentage)
      this.$emit('change',percentage)

    },
    init_data () {
      let temp = ['margin_top', 'margin_bottom', 'margin_left', 'margin_right']
      temp.forEach(key => {
        if (parseInt(this[key]) >= 0) {
          let key_ = key + '_display'
          this[key_] = Math.round(parseFloat(this[key]) / 100 * this.box_width_calculation())
          if(key === 'margin_top'){
            // console.log(this[key_])
          }
        }
      })
    },
    init_data_max () {
      let width = this.screenWidth
      this.top_max = width * 3
      this.bottom_max = width * 3
      this.left_max = width * 1
      this.right_max = width * 1
      if (this.isPadding) {
        this.left_max = width * 0.4
        this.right_max = width * 0.4
      }
      let temp = ['margin_top_max', 'margin_bottom_max', 'margin_left_max', 'margin_right_max']
      temp.forEach(key => {
        let key_ = key.replace('margin_', '')
        this[key] = Math.ceil(this[key_] / 100 * width)
      })
    }
  }
}
</script>

<style scoped type="text/css" lang="scss">
.panel_item_title {
  width: 70px;
}
.func_panel_handle_row {
  overflow: visible !important;
}
.margin_input_title{
    display: none;
  }
.my_margin_special{
  .margin_input_title{
    display: block;
  }
  .margin_border_box{
    border:none;
  }
  .jz-input-number{
    transform: translate(0,0);
    width: 70px;
    height: 32px;
  }
  .margin_input_title{
    height: 32px;
    line-height: 32px;
    position:absolute;
  }
  .title_top{
    left: 0;
    top: 0;
  }
  .margin_input_top{
    top: 0;
    left: 30px;
  }
  .title_bottom{
    top: 0;
    left:115px;
  }
  .margin_input_bottom{
    top: 0;
    left:145px;
  }
  .title_left{
    left: 0;
    top:45px;
  }
  .margin_input_left{
    top: 45px;
    left: 30px;
  }
  .title_right{
    top: 45px;
    left:115px;
  }
  .margin_input_right{
    top: 45px;
    left:145px;
  }
}
.mb_my_margin{
  .panel_item_title{
    color: #fff;
  }
  .func_panel_handle_row{
    margin-top: 0px;
  }
}
.no_left_right{
  .title_left,.title_right{
    display: none;
  }
  .margin_input_left,.margin_input_right{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_margin/index.vue